import React, { useEffect, useState } from 'react';
import classes from './TestList.module.css';
import  { Conversation } from './Conversation';

import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { ConProgress } from './ConProgress';
import { BackButton } from '../../buttons/BackButton';
 const GuestTestList = ()=> {

   const baseUrl = process.env.REACT_APP_API_URL;
   const navigate  = useNavigate();
   const {id} = useParams();
   const [data, setData] = useState();
   const [isFinished , setIsFinished] = useState(0);


   useEffect(()=>{

         axios.get(baseUrl+"/appi/quiz/public-tests/"+id).then((response)=>{
            let list = response?.data?.conversations_progress;
            let conversations = response?.data?.conversations;
            if(isFinished === 3) {
               setData( conversations );
            }else{
               setData( Array.isArray(list) ? list.filter(it => it.isFinished == isFinished ) : [] );
            }
            
            console.log(response?.data );
         })
         .catch((error) => {
            console.error(error);
         })
      

      
   },[isFinished])

   const goTo=(e,id,index)=>{
   
      
      console.log(id);
     
      localStorage.setItem("test-quiz-progress",id);
      axios.get(baseUrl+'/appi/quiz/test/'+ id + '/'+ 1, { withCredentials: true })
      .then(response=>{
        localStorage.setItem("test-quiz",JSON.stringify(response.data));
        console.log(response.data);
        navigate('/test');
        
      })
      .catch(error => {

      });
   }
   const initProgress=(e,convId,index)=>{
   
      let name = '';
      let type = 1;
      let student = 0;
      let telegramId = id;
      axios.post(baseUrl+'/appi/quiz/test/start',
         JSON.stringify({name,id:convId,type,student,telegramId}), {
             withCredentials: true,
             headers: {
                 'Content-Type': 'application/json',
             },
         }
     ).then(response=>{
       if(response.data.code){
        
         localStorage.setItem("test-quiz-progress",response.data.code);
         axios.get(baseUrl+'/appi/quiz/test/'+ response.data.code + '/'+ type, { withCredentials: true })
         .then(response=>{
           localStorage.setItem("test-quiz",JSON.stringify(response.data));
           console.log(response.data);
           navigate('/test');
           
         })
         .catch(error => {
   
         });
       }
      
     }).catch(error => {

     })
   }


  return (
    <div className={classes.list_view}>
               <div className={classes.header}>
               <div className={`${classes.btn} ${classes.newest} ${(isFinished === 3) ? classes.chosen : '' }`} 
                  onClick={(e) => setIsFinished(3)} >
                     Нові</div>
                  <div className={`${classes.btn}  ${classes.started} ${(isFinished === 0) ? classes.chosen : '' }`} 
                  onClick={(e) => setIsFinished(0)}>
                     Початі
                     </div>
                  <div className={`${classes.btn} ${classes.done} ${(isFinished === 1) ? classes.chosen : '' }`} 
                  onClick={(e) => setIsFinished(1)} >
                     Виконані</div>
               </div>
     {
      isFinished === 3 ? 
      (
         <Conversation list={data} classes={classes} onClick={initProgress}/>
      )
      :
      (
         <ConProgress list={data} classes={classes} onClick={goTo}/>
      )
     }
   
   <BackButton onClick={() => navigate(-1)} />
   </div>
  )
}
export default GuestTestList;